import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import {
  Container,
} from "reactstrap";
import React from 'react';
import { useRouter } from "next/router";
import styles from './styles.module.scss';
import Link from "next/link";

export default function InfoCards({
  global,
  pathPrefix,
  customClass = "",
  heading,
  paragraph1,
  paragraph2,
  content = [],
  buttonTitle = '',
  buttonLink = ''
}) {

  function useScrollToSection() {
    const router = useRouter();

    const scrollToSection = (href) => {
      const [path, hash] = href.split("#");

      if (hash && router.pathname === path) {
        document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
      } else {
        router.push(href);
      }
    };

    return scrollToSection;
  }

  const scrollToSection = useScrollToSection();

  const cardVariants = [
    { bulletClass: "card-bullet-sky-arrow", btnClass: "InfoTabBtn InfoTabBtn--light" },
    { bulletClass: "card-bullet-purple-dot", btnClass: "InfoTabBtn InfoTabBtn--dark" },
    { bulletClass: "card-bullet-purple-arrow", btnClass: "InfoTabBtn InfoTabBtn--light" },
  ];

  return (
    <section id='infoCards' className={`${styles.root} ${customClass} mb-4`}>
      <Container className="content-wrapper p-lg-5 pg-4 rounded-3 position-center">

        <div className="text-center w-75 mx-auto my-3 mt-4">
          <SourceFlowText global={global} path={`${pathPrefix}.heading`} type="html">
            {heading}
          </SourceFlowText>
        </div>

        <div className="text-center subheading w-75 mx-auto my-3 fw-bold">
          <SourceFlowText global={global} path={`${pathPrefix}.heading`} type="html">
            {paragraph1}
          </SourceFlowText>
        </div>

        <div className="text-center subheading w-75 mx-auto my-3">
          <SourceFlowText global={global} path={`${pathPrefix}.heading`} type="html">
            {paragraph2}
          </SourceFlowText>
        </div>

        <Row className="g-4 mt-4 mb-4 justify-content-center">
          {content.map((card, index) => {
            const { bulletClass, btnClass } = cardVariants[index] ?? cardVariants[0];

            return (
              <Col lg="4" md="6" sm="12" key={index}>
                <Card className={`infoCard h-100 ${bulletClass}`}>
                  <CardBody>

                    {card.icon && (
                      <div className="cardIcon">
                        <img src={card.icon} alt="" />
                      </div>
                    )}

                    <CardTitle tag="h4" className="cardTitle">{card.title}</CardTitle>

                    <div className="cardContent">
                      {card.body}
                    </div>

                    {(card.buttonLink || buttonLink) && (
                      <div className="mt-4">
                        <Link href={card.buttonLink || buttonLink} onClick={(e) => {
                          e.preventDefault();
                          scrollToSection(card.buttonLink || buttonLink);
                        }}>
                          <a className={`${btnClass} cta-button w-100 text-center text-decoration-none`}>
                            {card.buttonTitle || buttonTitle}
                          </a>
                        </Link>
                      </div>
                    )}

                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>

      </Container>
    </section>
  );
}